export default __webpack_public_path__ + "static/6k-7845ceac422778ad1f80a7845facf629.jpg";